#import "../../../src/common/graphql/EntityDocumentsFields.graphql"
mutation EntityDocumentRowProtection(
  $input: EntityDocumentRowProtectionInput!
) {
  entityDocumentRowProtection(input: $input) {
    entityDocument {
      ...EntityDocumentsFields
    }
  }
}
